import { useState } from 'react';

import { env } from 'core/constants/env.constants';
import { useUserPreferencesContext } from 'core/contexts/user-preferences/hooks/use-user-preferences-context.hook';
import { executeRequest } from 'core/utils/backend-service';
import { showErrorNotification } from 'core/utils/notification-service';
import { t } from 'core/i18n/i18n';
import { getUserAssistanceIP } from '../../service/user-assistance-ip.service';
import {
    buildUserAssistanceCheckUrl,
    buildUserAssistanceUrl,
    toUserAssistanceTooltipKey,
} from './use-user-assistance.business';
import { isHostReachable } from './use-user-assistance.utils';

export const useUserAssistance = () => {
    const [isCheckingUserAssistanceAvailability, setIsCheckingUserAssistanceAvailability] = useState<boolean>(false);
    const { userLanguage } = useUserPreferencesContext();
    const isUserAssistanceAvailable = env.VITE_USER_ASSISTANCE_AVAILABLE;

    const handleClickUserAssistance = () => {
        if (!isUserAssistanceAvailable) {
            return;
        }
        setIsCheckingUserAssistanceAvailability(true);
        executeRequest(async () => {
            try {
                const { ip } = await getUserAssistanceIP();
                const isReachable = await isHostReachable(buildUserAssistanceCheckUrl(ip));
                if (isReachable) {
                    globalThis.open(buildUserAssistanceUrl(ip, userLanguage), '_blank', 'noopener,noreferrer');
                } else {
                    showErrorNotification(t('app.header.options.help.unavailable'));
                }
            } finally {
                setIsCheckingUserAssistanceAvailability(false);
            }
        });
    };

    return {
        handleClickUserAssistance,
        isCheckingUserAssistanceAvailability,
        isUserAssistanceAvailable,
        userAssistanceTooltipKey: toUserAssistanceTooltipKey(isUserAssistanceAvailable),
    };
};
